import { useContext, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Row,
  Spinner,
} from "react-bootstrap";
import { AuthContext } from "../../auth";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { LoginImages, LogoBundarDark } from "../../assets/images/image";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { axiosAuth } from "../../api";

function Login() {
  const [username, setUser] = useState("");
  const [password, setPwd] = useState("");
  const { setUserInfo, setAccessToken } = useContext(AuthContext);
  const [disabled, setDisabled] = useState(false);
  const [isSubmittingLogin, setIsSubmittingLogin] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 600, maxWidth: 1024 });

  const navigate = useNavigate();

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const handleSubmitLogin = async (event) => {
    event.preventDefault();
    setIsSubmittingLogin(true);
    setDisabled(true);
    const data = {
      username: username,
      password: password,
    };
    try {
      const response = await axiosAuth.post(`/api/auth/login`, data, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
        },
      });

      const userInfo = response?.data.data;
      window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      setUserInfo(userInfo);
      const accessToken = response?.data.token;
      window.sessionStorage.setItem("accessToken", JSON.stringify(accessToken));
      setAccessToken(accessToken);

      Swal.fire({
        icon: "success",
        title: `Selamat datang ${response?.data.data.firstName} ${response?.data.data.lastName}`,
        showConfirmButton: false,
        timer: 2000,
      });
      setIsSubmittingLogin(false);
      setDisabled(false);

      if (userInfo?.role?.roleName === "superuser") {
        navigate("/pegawai");
      } else if (userInfo?.role?.roleName === "Sales") {
        navigate("/dashboard");
      } else if (userInfo?.role?.roleName === "Supervisor") {
        navigate("/dashboard-spv");
      } else if (userInfo?.role?.roleName === "Admin") {
        navigate("/pegawai");
      } else if (userInfo?.role?.roleName === "Finance") {
        navigate("/customer");
      } else if (userInfo?.role?.roleName === "Controller") {
        navigate("/sales");
      }

      setIsSubmittingLogin(false);
      setDisabled(false);
    } catch (err) {
      console.error(err);
      if (!err?.response) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan pada proses login!",
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      } else if (err.response?.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Oops...!",
          text: `${err.response?.data?.message}`,
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      } else if (err.response?.status === 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...!",
          text: `Periksa kembali Username dan Password anda`,
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      } else if (err.response?.status === 403) {
        Swal.fire({
          icon: "error",
          title: "Oops...!",
          text: `Terjadi kesalahan pada proses login!`,
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...!",
          text: `Terjadi kesalahan pada proses login!`,
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      }
    }
  };

  const styleResponsive = {
    minWidth: isMobile ? "90vw" : isTablet ? "75vw" : "75vw",
    maxWidth: isMobile ? "90vw" : isTablet ? "75vw" : "75vw",
  };

  const formStyles = {
    label: {
      fontFamily: "Poppins-Medium",
      color: "white",
    },
    input: {
      color: "#222",
      fontFamily: "Poppins-Regular",
      minHeight: "50px",
      borderColor: "#ced4da",
    },
  };

  return (
    <Container
      fluid
      className="vh-100 d-flex align-items-center justify-content-center"
    >
      <div id="cardLogin" style={styleResponsive}>
        <Row>
          <Col xs={12} md={12} lg={6} className="text-center">
            <div className="text-start mt-3 ms-3">
              <Image src={LogoBundarDark} fluid width={isMobile ? 80 : 80} />
            </div>
            <h4 className="mt-5 mx-4" style={{ fontFamily: "Poppins-Medium" }}>
              Selamat datang di aplikasi
            </h4>
            <h4 className="mb-4 mx-4" style={{ fontFamily: "Poppins-Medium" }}>
              CRM by Flashklik
            </h4>
            <div className="mb-5 text-center mx-4">
              <Image src={LoginImages} fluid width={isMobile ? 200 : 300} />
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} className="text-start my-auto">
            <div className="mx-4">
              <p
                className="text-center mb-5"
                style={{ fontFamily: "Poppins-Light" }}
              >
                Silahkan Login menggunakan Akun yang sudah ada!
              </p>
              <Form onSubmit={handleSubmitLogin}>
                <Form.Group className="mb-3">
                  <Form.Label style={formStyles.label} htmlFor="usernameLogin">
                    Username atau Email*
                  </Form.Label>
                  <Form.Control
                    id="username"
                    type="text"
                    disabled={disabled}
                    onChange={(e) => setUser(e.target.value)}
                    value={username}
                    required
                    style={formStyles.input}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label style={formStyles.label} htmlFor="passwordLogin">
                    Password*
                  </Form.Label>
                  <Form.Control
                    id="password"
                    type={passwordShown ? "text" : "password"}
                    disabled={disabled}
                    onChange={(e) => setPwd(e.target.value)}
                    value={password}
                    required
                    style={formStyles.input}
                  />
                  <p
                    className="mt-2"
                    onClick={togglePassword}
                    style={{
                      fontFamily: "Poppins-Regular",
                      cursor: "pointer",
                      maxWidth: "170px",
                    }}
                  >
                    {passwordShown ? "Hide" : "Show"} password{" "}
                    <span>
                      {passwordShown ? (
                        <BsEyeSlashFill size={20} />
                      ) : (
                        <BsEyeFill size={20} />
                      )}
                    </span>
                  </p>
                </Form.Group>
                <div className="d-grid gap-2 my-4">
                  {isSubmittingLogin ? (
                    <Button
                      id="actionButtonLogin"
                      variant="btn"
                      className="mb-4"
                      disabled
                    >
                      <Spinner animation="border" size="sm" />
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="btn"
                      id="actionButtonLogin"
                      className="mb-3"
                    >
                      Masuk
                    </Button>
                  )}
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default Login;
